import {Component} from '@angular/core';

import {BreadcrumbComponent} from "../../components/common/breadcrumb/breadcrumb.component";

@Component({
    selector: 'app-rgpd',
    imports: [
    BreadcrumbComponent
],
    templateUrl: './rgpd.component.html',
    styleUrls: ['./rgpd.component.css']
})
export class RgpdComponent {
}
